import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Project } from '../../model/project';
import { Client } from '../../model/client';
import { ProjectService } from '../project.service';
import {FileChooserComponent} from '../../FileChooser/file-chooser.component';
import {DuplicateOptionEnum} from '../../model/duplicateOptionEnum';
import {ImportDuplicateModalComponent} from '../../import-duplicate-modal/import-duplicate-modal.component';
import {CurrentContext} from '../../model/currentContext';
import {Questionnaire} from '../../model/questionnaire';
import {Terminal} from '../../model/terminal';
import {SharedRefreshService} from '../../service/sharedRefreshService';
import {StringUtil} from '../../util/stringUtil';


@Component({
    selector: 'project-infos',
    template: `
    <div class="card" style="padding: 10px;">
            <!--<div class="card-body">-->
              <div  class="w3-card-4">
                <header class="w3-container" style="background:linear-gradient(0deg,rgba(59,139,239,1) 0%,rgba(11,97,206,1) 100%);border-top-left-radius:5px;border-top-right-radius:5px;">
                  <h4><span><img style="height:40px;" src="../../../assets/images/033.png"></span>{{project.name}}</h4>
                  <div class="w3-padding w3-xlarge w3-text-white">
                    <div style="float:right;">
                      <button type="button" class="btn btn-primary btn-lg" (click)="onImport($event)" value="project" data-toggle="tooltip" data-placement="bottom" title="Import Questionnaire" style="margin-right:3px"><img alt="icon" class="titleBarIcon" src="../../../assets/images/001.png"></button>
                      <button type="button" class="btn btn-primary btn-lg" (click)="toggle()" data-toggle="tooltip" data-placement="bottom" title="Duplicate Project"><img  alt="icon" class="titleBarIcon" src="../../../assets/images/209.png"></button>
                    </div>
                    <div>
                      <button type="button" class="btn btn-danger btn-lg" (click)="removeProject()" data-toggle="tooltip" data-placement="bottom" title="Delete Project"><img  alt="icon" class="titleBarIcon" src="../../../assets/images/trash.png"></button>
                    </div>
                  </div>
                </header>
                <div class="w3-container">
                  <breadcrumb [path]="generateBreadCrumb()" (breadCrumbLink)="onBreadCrumbLink($event)"></breadcrumb>
                  <div>
                    <span><img class="mainLogoIcon" src="../../../assets/images/041.png" alt="Project Summary"></span><!--<i style="color:#ffe793; font-size: 80px; margin-left: 20px;margin-top: 15px;" class="fas fa-folder-open"></i></span>-->
                  </div>
                  <br/>
                  <form [formGroup]="myForm" novalidate>
                    <div class="col-md-6 form-group">
                      <div class="col-md-12">
                        <div class="input-group mb-3">
                            <div class="input-group-prepend">
                               <span class="input-group-text" id="basic-addon3">ID</span>
                            </div>
                            <input readonly  type="text" formControlName="projectID" class="form-control"  id="basic-id" aria-describedby="basic-addon3" [(ngModel)]="project.id"/>
                        </div>
                          <div class="input-group mb-3">
                              <div class="input-group-prepend">
                                  <span class="input-group-text" id="basic-addon3">{{'projectName'|translate}}</span>
                              </div>
                              <input readonly  type="text" formControlName="projectName" class="form-control"  id="basic-id" aria-describedby="basic-addon3" [(ngModel)]="project.name"/>
                          </div>
                          <div class="input-group mb-3">
                              <div class="input-group-prepend">
                                  <span class="input-group-text" id="basic-addon3">{{'projectCode'|translate}}</span>
                              </div>
                              <input readonly  type="text" formControlName="projectCode" class="form-control"  id="basic-id" aria-describedby="basic-addon3" [(ngModel)]="project.code"/>
                          </div>
                          <div class="input-group mb-3">
                              <div class="input-group-prepend">
                                  <span class="input-group-text" id="basic-addon3">{{'startDate'|translate}}</span>
                              </div>
                              <input readonly  type="text" formControlName="projectStartDate" class="form-control"  id="createdDate" aria-describedby="basic-addon3" [value]="extractDate(project.createdDate)"/>
                          </div>
                          <div class="input-group mb-3">
                              <div class="input-group-prepend">
                                  <span class="input-group-text" id="basic-addon3">{{'endDate'|translate}}</span>
                              </div>
                              <input readonly  type="text" formControlName="projectEndDate" class="form-control"  id="basic-id" aria-describedby="basic-addon3" [value]="extractDate(project.lastModifiedDate)"/>
                          </div>
                      </div>
                    </div>
                    <div class="col-md-6 form-group">
                      <div class="col-md-12">
                          <div class="input-group mb-3">
                              <div class="input-group-prepend">
                                  <span class="input-group-text" id="basic-addon3">{{'projectClient'|translate}}</span>
                              </div>
                              <select formControlName="projectClient" class="form-control" [(ngModel)]="project.client.id" (change)="onClientChange($event)">
                                  <option *ngFor="let client of clients" [value]="client.id">{{client.name}}</option>
                              </select>
                          </div>
                      </div>
                    </div>
                    <div class="col-md-12 form-group">
                      <div class="col-md-12">
                        <div class="row top-buffer">
                          <label>{{'projectTags'|translate}}</label>
                        </div>
                        <div class="tagsbox row top-buffer col-md-6">
                          <h3 style="margin-left:5px;margin-top:10px;float:left;" *ngFor="let tag of project.tags"><span class="badge badge-secondary">{{tag}}<span style="margin-left: 5px;" (click)="removeTag(tag)"><i style="color: red; font-size: 20px;" class="far fa-times-circle"></i></span></span></h3>
                        </div>
                        <div class="col-md-6 input-group mb-4" style="float:left; margin-left: 10px;margin-top:10px;">
                          <input type="text" class="form-control" placeholder="eg:Fusion,Merge,RFID" aria-label="Tags" aria-describedby="button-addon2" formControlName="projectTags">
                          <div class="input-group-append">
                            <button class="btn btn-outline-primary" type="button" id="button-addon2" (click)="addTag()">Add Tag</button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <br/>
                    <br/>
                    <br/>
                    <div class="col-md-6 form-group">
                      <div class="col-md-12">
                        <div class="row top-buffer">
                            <button type="button" class="btn btn-primary" (click)="onUpdateProject()">{{'save'|translate}}</button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                <footer class="w3-container w3-blue">
                  <h5></h5>
                </footer>
              </div>
        <!--</div>-->
        </div>
      <file-chooser [context]="_currentContext"></file-chooser>
      <import-duplicate-modal [forCopyIntention]="true" (duplicateOption)="onDuplicate($event)"></import-duplicate-modal>
    <generic-info-modal [hide]="_hideInfoModal" [title]="_genericModalTitle" [text]="_genericModalText"
                        (OkClick)="onOk()" [statusCode]="_statusCode"></generic-info-modal>
`,styles:[`.tagsbox {
    width: 100%;
    border: 1px dashed #0d47a1;
    overflow-y: auto;
    float: left;
    margin-top: 5px;
    margin-bottom: 5px;
    height: 50px;}
    h4{text-align: center;color:#ffffff;margin-top:20px;}
    .w3-container,.w3-panel{padding:0;}
    .mainLogoIcon{height:100px;margin-left:8px;}
    .titleBarIcon{height:40px;}

    .input-group-text {
        background: -webkit-linear-gradient(top, #648bf5, #2866f2);
        background: linear-gradient(to bottom, #648bf5 0%, #2866f2 100%);
        border-top: 1px solid #5a82eb;
        border-bottom: 1px solid #1758e7;
        color: #ffffff;
    }
    `]
})
export class ProjectInfosComponent implements OnInit, OnChanges {
     @Input('project') project: Project;
     @Input('clients') clients: Client[];
     @Output() breadCrumbLink:EventEmitter<Project|Questionnaire|Terminal>;
    // @Output() projectInfoRefresh: EventEmitter<any> = new EventEmitter();

     private _currentContext:CurrentContext;

     private _hideInfoModal = true;

     private _genericModalTitle = 'Project';

     private _genericModalText;

     private _statusCode = 100;


     public myForm: FormGroup;
     @ViewChild (FileChooserComponent) private fileChooser:FileChooserComponent;
     @ViewChild (ImportDuplicateModalComponent) private importDuplicate:ImportDuplicateModalComponent;


     constructor(private _projectService: ProjectService, private _refreshService:SharedRefreshService) {
        this.breadCrumbLink = new EventEmitter();
     }

     ngOnInit() {
        this.myForm = new FormGroup({
            projectName: new FormControl(),
            projectCode: new FormControl(),
            projectStartDate: new FormControl(),
            projectEndDate: new FormControl(),
            projectTags: new FormControl(),
            projectClient: new FormControl(),
            projectID: new FormControl()
        });

        this._currentContext.project = this.project;
    }

    onClientChange(event:any) {
        let c:Client = null;
        for (const client of this.clients) {
            if (client.id === event.target.value) {
                c = client;
                break;
            }
        }

        if (c != null) {
            this.project.client.username = c.username;
            this.project.client.password = c.password;
        }
    }

    onUpdateProject() {
        this._projectService.updateProject(this.project).subscribe(
            msg => {
                if(msg === 100) {
                    this._statusCode = 200;
                    this._genericModalText = 'Project has been successfully updated.';
                    this._genericModalTitle = 'Project';
                    this._hideInfoModal = false;
                } else if(msg === 102) {
                    this._statusCode = 301;
                    this._genericModalText = 'An error has occurred while updating project. Please contact admin.';
                    this._genericModalTitle = 'Project';
                    this._hideInfoModal = false;
                }

            });
    }


  removeProject() {
    this._projectService.removeProject(this.project.id)
      .subscribe(data => {
                const val = data as boolean;
              if(val === true) {
                  this._statusCode = 200;
                  this._genericModalText = 'Project deleted successfully.';
                  this._genericModalTitle = 'Project';
                  this._hideInfoModal = false;
              } else if(val === false) {
                  this._statusCode = 301;
                  this._genericModalText = 'An error has occurred while deleting project. Please contact admin.';
                  this._genericModalTitle = 'Project';
                  this._hideInfoModal = false;
              }
        },
        error => console.log('Error removing project'));
  }

  onImport(src:any) {
    this.fileChooser.toggleFileChooser('projects');
    this.fileChooser.setTarget('project');
  }

  onDuplicate(event: DuplicateOptionEnum) {
    this._projectService.createProject(this.project,event.valueOf())
      .subscribe(data => {
          if(data === 100) {
              this._statusCode = 200;
              this._genericModalTitle = 'Import & Copy';
              this._genericModalText = 'Project copied successfully.';
              this._hideInfoModal = false;
          } else if (data === 102) {
              this._statusCode = 301;
              this._genericModalTitle = 'Import & Copy';
              this._genericModalText = 'An error has occurred while copying project.';
              this._hideInfoModal = false;
          }

        },
        error => console.log('Error Add project'));
  }

  toggle() {
    this.importDuplicate.toggle();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(this._currentContext == null) {
       this._currentContext =  new CurrentContext();
    }
    this._currentContext.project = this.project;
  }

  private extractDate(date: string): string {
       return new Date(Number(date)).toString();
  }

  removeTag(tag: string) {
       const index = this.project.tags.indexOf(tag);
       this.project.tags.splice(index,1);
  }

  addTag() {
         console.log(this.myForm['controls'].projectTags.value);
         if(StringUtil.isEmptyOrNull(this.myForm['controls'].projectTags.value)) {
             this._statusCode = 250;
             this._genericModalText = 'You cannot add an empty tag';
             this._genericModalTitle = 'Project';
             this._hideInfoModal = false;
         } else {
             this.project.tags.push(this.myForm['controls'].projectTags.value);
         }
  }

  private generateBreadCrumb():Project[] {
    const crumbs:Project[] = [];

    crumbs.push(this.project);

    return crumbs;
  }

  onBreadCrumbLink($event: Project | Questionnaire | Terminal) {
    this.breadCrumbLink.emit($event);
  }

  onOk() {
        this._hideInfoModal = true;
        // location.reload(true);
       // this.projectInfoRefresh.emit();
      this._refreshService.refresh(true);
  }
}
